import { useQuery } from '@tanstack/react-query';
import { Select, SelectProps } from 'antd';
import { getProposalTypesDropdown } from 'src/apis/servicedesk/proposalType.api';

type ProposalTypeSelectProps = SelectProps & {};

export default function ProposalTypeSelect({
  value,
  onChange,
  style,
  allowClear,
  status,
  disabled
}: ProposalTypeSelectProps) {
  const proposalTypeDropdownQuery = useQuery({
    queryKey: ['proposalTypeDropdown'],
    queryFn: () => getProposalTypesDropdown(),
    staleTime: 60 * 1000
  });

  return (
    <Select
      disabled={disabled}
      status={status}
      allowClear={allowClear}
      value={proposalTypeDropdownQuery.isFetching ? undefined : value}
      style={style}
      onChange={onChange}
      options={proposalTypeDropdownQuery.data?.data.map((data) => ({ value: data.id, label: data.name }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={proposalTypeDropdownQuery.isFetching}
    />
  );
}
